module.exports = __webpack_public_path__ + "img/premium-proxies.e1ffe994.svg";